/* ActionTypes */
import { FETCH_SEASON_BY_ID } from './actionTypes';

/* Utils */
import { generateRequestActionCreator } from '../utils/generators/actionGenerators';

export const fetchSeasonById = generateRequestActionCreator(({
  showId,
  seasonNumber,
  sourceProvider,
}) => ({
  type: FETCH_SEASON_BY_ID,
  payload: {
    showId,
    seasonNumber,
    sourceProvider,
  },
}));
